import React from 'react';

export const Card: React.FC<{className?: string}> = (props) => {
  return (
    <div className={`bg-white shadow-md p-3 ${props.className}`}>
      {props.children}
    </div>
  )
}